import { ApplicationTeamPermissions } from '@organization/api/requests'
import { PermissionsPicker } from '@shared/components'
import { PermissionSection } from '@shared/types'
import { flattenScopedPermissions, toScopedPermissions } from '@shared/utils'

type Props = {
  sections: PermissionSection[]
  isLoading?: boolean
  /** Injectate de `Form.Item`. */
  value?: ApplicationTeamPermissions[]
  onChange?: (next: ApplicationTeamPermissions[]) => void
}

/**
 * Punte între `application_permissions` (`[{ application, permissions }]`, cum îl
 * așteaptă API-ul) și lista plată de chei compuse pe care o folosește `PermissionsPicker`.
 */
export const ApplicationPermissionsPicker = ({
  sections,
  isLoading,
  value,
  onChange
}: Props) => (
  <PermissionsPicker
    sections={sections}
    isLoading={isLoading}
    value={flattenScopedPermissions(value)}
    onChange={(keys) => onChange?.(toScopedPermissions(keys, value))}
  />
)
